import { findNextTaskPosition } from '@starflow/app/modules/generator/helpers';
import { viewportActions, updateTask, setSharedData } from '@starflow/app/store';

// 传入任务参数
export function getPositionInfo(data) {
  const { width, height } = data.params;
  const taskPositionInfo = {
    x: data.x,
    y: data.y,
    width,
    height,
  };

  if (typeof data.x === 'undefined' || typeof data.y === 'undefined') {
    // 执行之前，在画布上寻找合适的显示生成器
    const { x, y } = findNextTaskPosition();

    taskPositionInfo.x = x;
    taskPositionInfo.y = y;

    updateTask(data.id, taskPositionInfo);

    localStorage.setItem(`lastGeneratorRect`, JSON.stringify({ x, y, width, height }));

    viewportActions.locateRect(
      { x, y, width, height },
      { paddings: [100, 100, 200, 100], animate: true, fitView: true },
    );
  }

  // 临时把生成器坐标存下来，下个节点继续用
  if (data.isAuto) {
    setSharedData('autoRunningPositionInfo', taskPositionInfo);
  }

  return taskPositionInfo;
}
